import { useMutation, useQuery } from '@tanstack/react-query';
import {
	getAvailableMasks,
	getInvitationDetails,
	getUserByEmail,
	getUserCampaignInvitations,
	getUserCampaignReward,
	inviteGuest,
	reserveMask,
	sendGuestInvite,
	updateUserCampaignInvitation,
	updateUserContactInfo,
	updateUserPassword,
	userLogin
} from './fetchers';

export const useGetAvailableMasks = ({
	restaurantID,
	campaignID
}) => {
	return useQuery({
		queryKey: ['availableMasks', restaurantID, campaignID],
		queryFn: () => getAvailableMasks({
			restaurantID,
			campaignID
		}),
		enabled: Boolean(restaurantID && campaignID),
	});
};

export const useGetInvitationDetails = ({
	restaurantID,
	campaignID,
	campaignInviteID
}) => {
	return useQuery({
		queryKey: ['invitationDetails', restaurantID, campaignID, campaignInviteID],
		queryFn: () => getInvitationDetails({
			restaurantID,
			campaignID,
			campaignInviteID
		}),
		enabled: !!(restaurantID && campaignID && campaignInviteID)
	});
};

export const useGetUserByEmail = ({ email, options }) => {
	return useQuery({
		queryKey: ['getUserByEmail', email],
		queryFn: () => getUserByEmail({ email }),
		...options
	});
};

export const useUserLogin = ({
	email,
	pw
}) => {
	return useQuery({
		queryKey: ['userLogin', email, pw],
		queryFn: () => userLogin({ email, pw }),
		enabled: false
	});
};

export const useGetUserCampaignInvitations = ({
	restaurantID,
	campaignID,
	userID
}) => {
	return useQuery({
		queryKey: ['getUserCampaignInvitations', restaurantID, campaignID, userID],
		queryFn: () => getUserCampaignInvitations({
			restaurantID,
			campaignID,
			userID
		}),
		enabled: !!(restaurantID && campaignID && userID)
	});
};

export const useGetUserCampaignReward = ({
	restaurantID,
	campaignID,
	userID
}) => {
	return useQuery({
		queryKey: ['getUserCampaignReward', restaurantID, campaignID, userID],
		queryFn: () => getUserCampaignReward({
			restaurantID,
			campaignID,
			userID
		}),
		enabled: !!(restaurantID && campaignID && userID)
	});
};

export const useReserveMask = (options) => {
	return useMutation({
		mutationFn: reserveMask,
		...options
	});
};

export const useInviteGuest = (options) => {
	return useMutation({
		mutationFn: inviteGuest,
		...options
	});
};

export const useUpdateUserCampaignInvitation = (options) => {
	return useMutation({
		mutationFn: updateUserCampaignInvitation,
		...options
	});
};

export const useUpdateUserContactInfo = (options) => {
	return useMutation({
		mutationFn: updateUserContactInfo,
		...options
	});
};

export const useUpdateUserPassword = (options) => {
	return useMutation({
		mutationFn: updateUserPassword,
		...options
	});
};

export const useSendGuestInvite = (options) => {
	return useMutation({
		mutationFn: sendGuestInvite,
		...options
	});
};
